/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.profile

data class Profile(
    val id: String,
    val displayName: String?,
    val tier: String,
    val defaultSessionFee: Long?,
    val onboardingStep: OnboardingStep,
    val onboardingCompleted: Boolean,
    val reminderScheduleDays: List<Int> = listOf(3, 7, 14),
    val maxReminders: Int = 3,
    val reminderTemplate: String = studio.oddpods.cauce.core.model.reminder.DEFAULT_REMINDER_TEMPLATE,
)
